import { useAppStore } from '@src/shared/zustand/store';

export const setConfirmed = (value: boolean) =>
  useAppStore.setState({ confirmed: value });
